module.exports = __webpack_public_path__ + "img/teacher_img.90fb3f88.jpg";